<div class="video-container">
  <h2>Video</h2>
  <h3>Video Attachment</h3>
  <div *ngIf="!feature.value" class="dropzone" appDnd (fileDropped)="onFileDropped($event)">
    <p>Drag and drop one video file here</p>
    <p>or</p>
    <a class="browse-link" (click)="fileDropRef.click()">Browse by clicking here</a>
    <input type="file" #fileDropRef id="fileDropRef"
                      (change)="fileBrowseHandler($event.target.files)" accept="video/*"
                      [attr.maxFileSize]="maxVideoSize" />
    <p class="file-info">Compatible formats : mp4, mov, api, mpg, mkv. Limit of {{maxVideoSize / 1000000}} mb.</p>
  </div>
  
  <div class="video-content" *ngIf="feature.value">
    <div class="video-preview">
      <div class="video-player-container">
        <ng-container *ngFor="let video of [videoElement]; trackBy: identifyVideo">
          <video #videoPlayer controls class="video-player" preload="none">
            <source [src]="getVideoUrl()" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </ng-container>
        <div class="video-controls">
          <span class="file-name" title="{{feature.value.name}}">{{feature.value.name}}</span>
          <button pButton icon="pi pi-trash" class="p-button-danger p-button-rounded" 
                  (click)="deleteFeatureVideo()" 
                  pTooltip="Remove video" tooltipPosition="top"></button>
        </div>
      </div>
    </div>
    
    <div class="output-type-selector">
      <h3>Video Output Type</h3>
      <p-selectButton [options]="outputTypeOptions" 
                      [(ngModel)]="feature.value.outputType"
                      (onChange)="onOutputTypeChange($event)">
      </p-selectButton>
      <small class="output-type-hint" *ngIf="feature.value.outputType === videoOutputTypes.AugmentedReality">
        AR videos will be displayed in augmented reality mode
      </small>
      <small class="output-type-hint" *ngIf="feature.value.outputType === videoOutputTypes.TwoDimensional">
        2D videos will be displayed in standard video player
      </small>
    </div>
  </div>
</div>